/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsexplainsignups2Inputs */

const en_statsexplainsignups2 = /** @type {(inputs: Statsexplainsignups2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New accounts per day. Web guests without an account are not counted.`)
};

const de_statsexplainsignups2 = /** @type {(inputs: Statsexplainsignups2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Konten pro Tag. Web-Gäste ohne Konto zählen nicht.`)
};

/**
* | output |
* | --- |
* | "New accounts per day. Web guests without an account are not counted." |
*
* @param {Statsexplainsignups2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsexplainsignups2 = /** @type {((inputs?: Statsexplainsignups2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsexplainsignups2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsexplainsignups2(inputs)
	return de_statsexplainsignups2(inputs)
});
export { statsexplainsignups2 as "statsExplainSignups" }